export default "__VITE_ASSET__DPBHSvhY__"